import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/src/app/(pub)/articles/error.tsx");
